<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="生成记录">
            <el-table
                :data="recordList"
                style="width: 100%"
                :highlight-current-row="true"
                stripe
                tooltip-effect="dark"
                ref="multipleTable"
                v-loading="isLoading"
                header-cell-class-name="table-back"
                class="list-table"
            >
                <el-table-column  label="站点" prop="site_name"  width="100"   align="center"></el-table-column>
                <el-table-column  label="楼盘名称" prop="house_name"  align="center">
                    <template slot-scope="scope">
                        <a :href="scope.row.house_url" target="_blank" style="color:#0099FF;">{{scope.row.house_name}}</a>
                    </template>
                </el-table-column>
                <el-table-column  label="子话题" prop="topic_name"  align="center">
                    <template slot-scope="scope">
                        <a :href="scope.row.topic_url" target="_blank" style="color:#0099FF;">{{scope.row.topic_name}}</a>
                    </template>
                </el-table-column>
                <el-table-column  label="问题" prop="ask_name"  align="center">
                    <template slot-scope="scope">
                        <a :href="scope.row.ask_url" target="_blank" style="color:#0099FF;">{{scope.row.ask_name}}</a>
                    </template>
                </el-table-column>
                <el-table-column  label="问题生成时间" prop="created_at"  align="center"></el-table-column>
                <el-table-column  label="生成回答数" prop="answer_num"  align="center"></el-table-column>
                <el-table-column  label="操作" prop=""  align="center">
                    <template slot-scope="scope">
                        <el-button v-permission="'operating.house-topic.house-topic-bank.edit'"  size="mini" @click="checkDetail(scope.row)"
                            >回答生成记录</el-button>
                    </template>
                </el-table-column>
            </el-table>   
             <template v-if="recordList.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>
        </el-tab-pane>
    </el-tabs>
    <answer-rec ref="recordDetail" />
    </div>

</template>
<script>
import answerRec from './answerRec.vue'
import {getTopicAskwerRecord} from '@/service/topicBank'

export default {
    name: 'record',
    components: {
        answerRec
    },
    data () {
        return {
           recordList:[],
            condition:{
                record_id:'',
                total: 0,
                per_page: 10,
                page: 1,
            },
           isLoading:false,
        }
    },
    mounted(){
        this.initData();
    },
    methods: {
        async initData() {
            this.condition.record_id = this.$route.query.id
            this.recordList=[]
            await getTopicAskwerRecord(this.condition).then((data) => {
                this.condition.total=data.total
                this.recordList = data.data
            })
        },
        checkDetail(row){
                this.$refs.recordDetail
            && this.$refs.recordDetail.open(row);
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
    }
}
</script>
<style scoped>

</style>